import { informativeIcon, successIcon, warningIcon, errorIcon } from "../../assets";

const modalAlertTypes = {
  informative: {
    icon: informativeIcon,
    color: '#4D4AF5',
  },
  success: {
    icon: successIcon,
    color: '#22C55E',
  },
  warning: {
    icon: warningIcon,
    color: '#F59E0B',
  },
  error: {
    icon: errorIcon,
    color: '#EF4444',
  },
};

const StaticModal = ({ type, icon, title, message, children }) => {

  const modalAlertType = modalAlertTypes[type] || modalAlertTypes.informative;

  return (
    <div className={`modal-alert-content`} style={{ background: modalAlertType.color }}>

      <div className="modal-alert-header-icon">
        <img src={modalAlertType.icon} alt="modal-alert-icon" />
      </div>

      <div className="modal-alert-content-inner" >
        {icon && (
          <img src={icon} className="modal-alert-content-icon" alt="modal-alert-icon" />
        )}

        <div className="modal-alert-content-texts">
          <div className="modal-alert-content-title">
            {title}
          </div>

          <div className="modal-alert-content-description">
            {message}
          </div>
        </div>

        {children}

      </div>

    </div>
  );
};

export default StaticModal;
